import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BatchItem } from 'src/interfaces/batch';
import { RawOrderItem } from 'src/interfaces/order';
import { OrderItem } from 'src/interfaces/order-item';

interface DialogData {
  rawOrderItem: RawOrderItem | null,
  orderItem: OrderItem | null
}

@Component({
  selector: 'app-order-item-details-dialog',
  templateUrl: './order-item-details-dialog.component.html',
  styleUrls: ['./order-item-details-dialog.component.scss']
})
export class OrderItemDetailsDialogComponent implements OnInit {

  displayedColumns: string[] = [
    'id',
    'barcode',
    'medicine_number'
  ];

  batchItems: BatchItem[] = [];

  constructor(
    public _dialogRef: MatDialogRef<OrderItemDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {

    if (this.data.orderItem)
      if (this.data.orderItem.batch_items) {
        this.batchItems = this.data.orderItem.batch_items;
      }

    if (this.data.rawOrderItem) {
      if (this.data.rawOrderItem.batch_items) {
        this.batchItems = this.data.rawOrderItem.batch_items;
      }
    }

  }

  closeDialog() {
    this._dialogRef.close(true);
  }

}
